import type { IPopupNotification } from '@/types/Data'
import type { IGetPopupNotificationList, IPayloadPopupNotification } from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class PopupNotificationServices extends BaseService {
  GetPopupNotificationList(payload: IGetPopupNotificationList) {
    return this.GET<IPopupNotification[]>(this.PATHS.GET_POPUP_NOTIFICATION_LIST, payload)
  }

  CreatePopupNotification(payload: IPayloadPopupNotification) {
    return this.POST<IPopupNotification>(
      this.PATHS.CREATE_POPUP_NOTIFICATION,
      JsonToFormData(payload),
    )
  }

  UpdatePopupNotification(payload: IPayloadPopupNotification) {
    return this.PUT<IPopupNotification>(
      this.PATHS.UPDATE_POPUP_NOTIFICATION,
      JsonToFormData(payload),
    )
  }

  DeletePopupNotification(id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_POPUP_NOTIFICATION, null, { id })
  }
}
